<template>
    <div
        elevation="0"
        class="position-relative"
        v-if="book.id"
    >
        <v-card
            elevation="0"
            @click="setToBuyBook"
            @mouseover="hover = true"
            @mouseleave="hover = false"
        >
            <v-row justify="center">
                <img
                    :src="`https://assets.beeverso.org/lbr/image/${book.resourceDir}/cover_small.jpg`"
                    class="book-img transition-all"
                    max-height="134"
                    max-width="100"
                    @load="handleLoaded"
                    alt="Av"
                />
                <v-skeleton-loader
                    v-if="!loaded"
                    class="mt-3 position-absolute opacity-none"
                    height="130"
                    width="130"
                    type="image"
                    :transition="'scale-transition'"
                />
            </v-row>
            <!-- <v-overlay absolute opacity="0" style="cursor:pointer;">
                <v-img :src="favoriteSrc" class="mt-3 bg-orange border-radius-5" height="50" max-width="60" v-show="hover"></v-img>
            </v-overlay> -->
        </v-card>
        <v-row justify="center">
            <v-chip
                label
                color="white"
                class="px-1 font-weight-bold user-purchased-chip"
                @click="setToBuyBook"
                v-if="!book.userPurchased"
            >
                <v-img
                    :src="require('@/assets/img/icons/beecoins.png')"
                    height="28"
                    width="28">
                </v-img>
                <span class="line-height-100">{{ book.price }}</span>
            </v-chip>
            <v-chip
                label
                color="white"
                class="px-1 font-weight-bold user-purchased-chip"
                @click="setToBuyBook"
                v-else
            >
                <v-img
                    :src="require('@/assets/img/icons/check-stroke.png')"
                    height="32"
                    width="32">
                </v-img>
            </v-chip>
        </v-row>
        <!-- <v-row justify="center" class="my-2">
            <v-img
                src="/img/user/star-filled.svg"
                class="mx-1"
                max-height="15"
                max-width="15"
                v-for="n in book.rating"
                :key="n + '-filled'"
            />
            <v-img
                src="/img/user/star.svg"
                class="mx-1"
                max-height="15"
                max-width="15"
                v-for="n in (5-book.rating)"
                :key="n"
            />
        </v-row>
        <v-row justify="center" class="my-2 mx-4 color-text">
            {{ book.title }}
        </v-row> -->
    </div>
</template>

<script>

import { mapState } from 'vuex'
import BookUserFavoriteService from '../../services/bookUserFavorite'

const defaultBook = {
    active: false,
    bookAbstract: '',
    commentsCount: 0,
    id: 0,
    name: '',
    userPurchased: false,
    rating: 0,
    resourceDir: '',
    title: '',
    userFavorite: false
}

export default {
    props: {
        book: {
            type: Object,
            default: defaultBook,
        }
    },
    data() {
        return {
            favorite: false,
            hover: false,
            loaded: false
        }
    },
    mounted() {
        this.favorite = this.book.userFavorite
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
        favoriteSrc() {
            return this.favorite ? '/img/user/icon-favorite-selected.svg' : '/img/user/icon-favorite.svg'
        }
    },
    methods: {
        handleLoaded() {
            this.loaded = true
        },
        setFavorite () {
            this.favorite = !this.favorite
            this.$emit('favorite',
                { id: this.book.id, favorite: this.favorite }
            )
            if (this.favorite) {
                BookUserFavoriteService.addFavoriteBookToUser({
                    user: { id: this.user.id },
                    book: { id: this.book.id }
                })
                .catch((error) => console.error(error))
            } else {
                BookUserFavoriteService.deleteFavoriteBookToUser(
                    this.user.id,
                    this.book.id
                )
                .catch((error) => console.error(error))
            }
        },
        setToBuyBook() {
            this.$emit('toBuy', this.book)
        }
    }
}
</script>

<style lang="css">
.color-text {
    color: #4A3216;
}
.book-img {
    border-radius: 4px;
    display: block;
    /* height: 100%; */
    width: 70%;
    z-index: 1;
}
.v-chip.user-purchased-chip{
    border: 1px solid #F0F2F4!important;
    background-color: #f0f2f4bb!important;
    position: absolute;
    bottom: -24px;
    z-index: 1;
    @media screen and (min-width: 600px) {
        height: 40px;
        font-size: 1em;
    }
}
</style>
